<sim-component-loading-container
	[showBackDrop]="true"
	[loadingMessage]="T.GLOBAL_TEXT_LOADING | translate"
	[isLoading]="loadingTrainingRooms"
	[loadingIcon]="'fad fa-door-open'"
/>

<div>
	<span class="actionsWrapper">
		<button (click)="filterPanel.toggle()" class="filterPanelButton" color="accent" mat-icon-button>
			<mat-icon [fontSet]="isFilterOpen ? 'far' : 'fas'" fontIcon="fa-filter" />
		</button>
		<ng-content select="[planViewToggle]" />
	</span>
</div>
<mat-expansion-panel
	#filterPanel
	(closed)="isFilterOpen = false"
	(opened)="isFilterOpen = true"
	[class.open]="isFilterOpen"
	class="filterPanel"
	hideToggle
>
	<ng-template matExpansionPanelContent>
		<sim-tags-chip-input
			(optionCleared)="removeRoomTag($event)"
			(optionSelected)="addRoomTag($event)"
			[isEditMode]="false"
			[placeholder]="T.SIM_ROOM_PLANNER_ROOM_TAGS | translate"
			[tagType]="TagType.Room"
		/>
	</ng-template>
</mat-expansion-panel>

<!--CONTENT-->
@if ((!loadingTrainingRooms && !areGroupsEmpty()) || hasTTTRooms()) {
	<mat-tab-group
		color="accent"
		[class.hideTabHeader]="
			isDebriefing ? true : viewedInRoomPlanner ? false : !hasVirtualRooms() && !hasLicenseModule(Modules.TrainTheTrainer)
		"
		[mat-stretch-tabs]="false"
		(selectedTabChange)="roomTypeTabChanged($event)"
		[style.display]="!loadingTrainingRooms ? 'block' : 'none'"
	>
		<!--PHYSICAL ROOMS-->
		@if (filteredRoomGroups?.length >= 1) {
			<mat-tab>
				<ng-template mat-tab-label>
					<mat-icon inline fontSet="fad" fontIcon="fa-door-open" />
					<span class="matTabLabelText">
						{{ T.SIM_ROOM_PLANNER_PHYSICAL_ROOMS | translate }}
					</span>
				</ng-template>
				<ng-template matTabContent>
					<mat-tab-group
						[class.disableSelection]="disableSelection"
						[class.hideTabHeader]="enableTabHeaderHidden && filteredRoomGroups?.length === 1"
						[class.selectedNotActive]="selectGroupDeselectRoom && roomIsSelected"
						[class.draggableRooms]="collapseAllCards"
						[class.loadingTrainingRooms]="loadingTrainingRooms"
						class="matTabTrainingRoomNavigationPanel"
						[mat-stretch-tabs]="false"
						color="accent"
						(selectedTabChange)="groupChanged($event)"
						(click)="tabClick($event)"
					>
						@for (trainingRoomGroup of filteredRoomGroups; track trainingRoomGroup; let groupIndex = $index) {
							@if (
								trainingRoomGroup.trainingRooms &&
								trainingRoomGroup.trainingRooms.length > 0 &&
								isOtherTrainingRoomGroupAndHasOnlyVirtualAndTTTRooms(trainingRoomGroup)
							) {
								<mat-tab
									[disabled]="planView && isGroupOtherGroup(filteredRoomGroups[groupIndex])"
									label="{{ trainingRoomGroup.name }}"
								>
									<ng-template matTabContent>
										@if (planView) {
											<sim-training-room-plan-view
												[trainingRooms]="filteredRooms"
												[trainingRoomGroupIndex]="groupIndex"
												[trainingRoomGroup]="trainingRoomGroup"
												[readOnly]="planViewReadOnly"
												[selectedTrainingRooms]="selectedTrainingRooms"
												(onTrainingRoomClicked)="fireTrainingRoomClicked($event.trainingRoom, $event.checked)"
											/>
										}
										@if (!planView && !fromSignageView) {
											<div
												cdkDropList
												[cdkDropListConnectedTo]="connectedLists"
												[class.notDraggable]="!enableDraggingRooms"
												class="tabContent tabContentForRoomGroup"
											>
												@for (trainingRoom of trainingRoomGroup.trainingRooms; track trainingRoom) {
													@if (
														(!isTrainTheTrainerRoom(trainingRoom) &&
															trainingRoom.type === TrainingRoomType.Physical) ||
														(showNonSimstationRooms
															? trainingRoom.type === TrainingRoomType.NonSimulation
															: false)
													) {
														<sim-training-room-button
															[disabled]="
																roomCapability === RoomCapability.Debriefing &&
																disableIfNoOnlineDebriefingPlayers &&
																allDebriefingPlayersOffline(trainingRoom)
															"
															[trainingRoomGroup]="trainingRoomGroup"
															[allowSelectionWhenOccupied]="allowSelectionWhenOccupied"
															[class.checked]="getChecked(trainingRoom)"
															(click)="clickedTest()"
															[dragging]="isRoomDragging(trainingRoom)"
															[id]="trainingRoom.id + 'rt'"
															cdkDrag
															[cdkDragData]="{
																item: trainingRoom,
																type: DraggedItemType.Room,
															}"
															[cdkDragDisabled]="!enableDraggingRooms"
															[draggable]="enableDraggingRooms"
															[isChecked]="getChecked(trainingRoom)"
															[isButtonView]="
																expandAllCards
																	? false
																	: collapseAllCards
																		? trainingRoomGroup.trainingRooms.length > 8
																		: trainingRoomGroup.trainingRooms.length > 8
															"
															[buttonState]="getButtonState(trainingRoom)"
															[trainingRoom]="trainingRoom"
															(onTrainingRoomClicked)="
																fireTrainingRoomClicked($event.trainingRoom, $event.checked)
															"
														/>
													}
												}
											</div>
										}
									</ng-template>
								</mat-tab>
							}
						}
					</mat-tab-group>
				</ng-template>
			</mat-tab>
		}
		<!--VIRTUAL ROOMS-->
		@if (!isDebriefing && (hasVirtualRooms() || viewedInRoomPlanner)) {
			<mat-tab>
				<ng-template mat-tab-label>
					<mat-icon inline fontSet="fas" fontIcon="fa-object-group" />
					<span class="matTabLabelText">
						{{ T.SIM_ROOM_PLANNER_VIRTUAL_ROOMS | translate }}
					</span>
				</ng-template>
				<ng-template matTabContent>
					<div class="tabContent">
						@if (!hasVirtualRooms()) {
							<span class="noRoomsCon">
								<span class="mat-h2 text">
									{{ T.TRAINING_ROOM_NAVIGATION_NO_VIRTUAL_ROOMS_FOUND | translate }}
								</span>
								<sim-button
									[label]="T.CREATE_VIRTUAL_ROOM_DIALOG_BUTTON"
									[icon]="{fontSet: 'fad', fontIcon: 'fa-plus'}"
									(onClick)="openCreateVirtualRoomDialog()"
								/>
							</span>
						}
						@for (trainingRoom of filteredRooms; track trainingRoom) {
							<div cdkDropList [cdkDropListConnectedTo]="connectedLists">
								@if (trainingRoom.type === TrainingRoomType.Virtual) {
									<sim-training-room-button
										[disabled]="
											roomCapability === RoomCapability.Debriefing &&
											disableIfNoOnlineDebriefingPlayers &&
											allDebriefingPlayersOffline(trainingRoom)
										"
										[allowSelectionWhenOccupied]="allowSelectionWhenOccupied"
										[class.checked]="getChecked(trainingRoom)"
										(click)="clickedTest()"
										[dragging]="isRoomDragging(trainingRoom)"
										[id]="trainingRoom.id + 'rt'"
										cdkDrag
										[cdkDragData]="{
											item: trainingRoom,
											type: DraggedItemType.Room,
										}"
										[cdkDragDisabled]="!enableDraggingRooms"
										[draggable]="enableDraggingRooms"
										[isChecked]="getChecked(trainingRoom)"
										[isButtonView]="false"
										[buttonState]="getButtonState(trainingRoom)"
										[trainingRoom]="trainingRoom"
										(onTrainingRoomClicked)="fireTrainingRoomClicked($event.trainingRoom, $event.checked)"
									/>
								}
							</div>
						}
					</div>
				</ng-template>
			</mat-tab>
		}
		<!--TTT ROOMS-->
		@if (!isDebriefing && hasLicenseModule(Modules.TrainTheTrainer) && (hasTTTRooms() || viewedInRoomPlanner)) {
			<mat-tab>
				<ng-template mat-tab-label>
					<mat-icon inline fontSet="far" fontIcon="fa-file-video" />
					<span class="matTabLabelText">
						{{ T.TRAINING_ROOM_NAVIGATION_TTT_LABEL | translate }}
					</span>
				</ng-template>
				<ng-template matTabContent>
					<div class="tabContent">
						@if (!hasTTTRooms()) {
							<span class="noRoomsCon">
								<span [innerHTML]="T.TRAINING_ROOM_NAVIGATION_TTT_NO_ROOMS_FOUND | translate" class="mat-h2 text"></span>
							</span>
						}
						@for (trainingRoom of filteredRooms; track trainingRoom) {
							@if (isTrainTheTrainerRoom(trainingRoom)) {
								<sim-training-room-button
									[disabled]="
										roomCapability === RoomCapability.Debriefing &&
										disableIfNoOnlineDebriefingPlayers &&
										allDebriefingPlayersOffline(trainingRoom)
									"
									[allowSelectionWhenOccupied]="allowSelectionWhenOccupied"
									[class.checked]="getChecked(trainingRoom)"
									(click)="clickedTest()"
									[dragging]="isRoomDragging(trainingRoom)"
									[id]="trainingRoom.id + 'rt'"
									cdkDrag
									[cdkDragDisabled]="!enableDraggingRooms"
									[draggable]="enableDraggingRooms"
									[isChecked]="getChecked(trainingRoom)"
									[isButtonView]="false"
									[buttonState]="getButtonState(trainingRoom)"
									[trainingRoom]="trainingRoom"
									(onTrainingRoomClicked)="fireTrainingRoomClicked($event.trainingRoom, $event.checked)"
								/>
							}
						}
					</div>
				</ng-template>
			</mat-tab>
		}
	</mat-tab-group>
} @else {
	<span class="noRoomsCon">
		<span class="mat-h2 text">
			{{ T.TRAINING_ROOM_NAVIGATION_NO_ROOMS_FOUND | translate }}
		</span>
	</span>
}
